import template from './index.jst';
import './index.styl';
import { CoreLeagueInvitesView } from '../../../../../core/views';

/**
 * @desc League Invites View Class
 * This class using on league loin page ('fantasy/league/:id/manage/invites')
 */
export default class LeagueInvitesView extends CoreLeagueInvitesView {

	get template() {
		return template;
	}

	get className() {
		return "league-invites-page shadow";
	}
}